/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon32Regular = forwardRef('FoodDrinkAlcoGlassWineIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M9.5 9a1 1 0 0 0 0 2h13a1 1 0 1 0 0-2h-13Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v4.5c0 5.738-4.393 10.45-10 10.955V28h6a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h6v-6.545C9.393 20.95 5 16.238 5 10.5V6Zm3-1a1 1 0 0 0-1 1v4.5a9 9 0 1 0 18 0V6a1 1 0 0 0-1-1H8Z" })));
});
